// GLOBAL VARIABLES
import { COLUMNS as GLOBAL_COLUMNS } from 'columns.js';
import { COLUMNS as INVENTORY_COLUMNS } from 'routers/interface/routes/inventory/columns.js';

// PARTS
import Table from 'parts/table/Table';

// VARIABLES
export const COLUMNS = [
  {
    ...GLOBAL_COLUMNS.deliveredDate,
    key: 'date'
  },
  {
    ...GLOBAL_COLUMNS.customer(),
    key: 'customer'
  },
  GLOBAL_COLUMNS.newUsed,
  {
    ...GLOBAL_COLUMNS.purchaseLease,
    key: 'sale_type'
  },
  GLOBAL_COLUMNS.stockNumber,
  {
    ...GLOBAL_COLUMNS.makeModel,
    key: 'vehicle'
  },
  {
    ...GLOBAL_COLUMNS.trades,
    key: 'trade'
  },
  GLOBAL_COLUMNS.frontendGross,
  GLOBAL_COLUMNS.amGross,
  GLOBAL_COLUMNS.fmGross,
  {
    ...GLOBAL_COLUMNS.backendGross,
    key: 'be_gross'
  },
  GLOBAL_COLUMNS.totalGross,
  {
    ...GLOBAL_COLUMNS.salesPerson,
    component: Table.List,
    key: 'sales_person'
  },
  {
    ...GLOBAL_COLUMNS.amAssignment,
    key: 'am_manager'
  },
  {
    ...GLOBAL_COLUMNS.fmAssignment,
    key: 'fm_manager'
  },
  // CUSTOM TABLE COLUMNS
  {
    ...GLOBAL_COLUMNS.purchasedDate,
    key: 'purchase_date'
  },
  {
    ...GLOBAL_COLUMNS.retailWholesale,
    key: 'is_for_wholesale'
  },
  {
    ...GLOBAL_COLUMNS.inventorySource,
    key: 'inventory_type'
  },
  GLOBAL_COLUMNS.ageOfVehicle,
  {
    ...GLOBAL_COLUMNS.mileage,
    key: 'miles'
  },
  {
    ...GLOBAL_COLUMNS.acv,
    key: 'invoice_cost'
  },
  {
    ...GLOBAL_COLUMNS.dmsInvoice,
    key: 'dms_invoice_price'
  },
  {
    ...GLOBAL_COLUMNS.inventoryStatus,
    key: 'inventory_status_code'
  },
  {
    ...INVENTORY_COLUMNS.warranty,
    key: 'warranty_type_code'
  }
];
